import { useState } from "react";
import { AnimatePresence, motion, useMotionValueEvent, useScroll } from "motion/react";
import { Phone } from "lucide-react";
import { Button } from "./Buttons";
import { PHONE_HREF } from "../config";

/** Sticky "Book / Call" bar that slides up on phones once the hero is passed. */
export default function MobileBookBar() {
  const [show, setShow] = useState(false);
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, "change", (y) => setShow(y > 520));
  return (
    <AnimatePresence>
      {show && (
        <motion.div className="mbar" initial={{ y: 100 }} animate={{ y: 0 }} exit={{ y: 100 }}
          transition={{ type: "spring", stiffness: 380, damping: 34 }}>
          <Button href={PHONE_HREF} variant="blue-outline" className="mbar__call" aria-label="Call the salon">
            <Phone aria-hidden="true" />
          </Button>
          <Button to="/booking" className="mbar__book">Book an appointment</Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
